module.exports = __webpack_public_path__ + "static/slide-journey-5e4db8cd7bd172d54abbb1861f512cc9.svg";